<template>
    <div v-if="isLoading" class="flex justify-center items-center py-20">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
    </div>  
  <div v-else-if="project.project_id" class="font-inter space-y-5">
    <!-- Loading indicator -->

    <!-- In Progress Tasks -->
    <!-- <div v-else> -->
    <div
      v-if="
        taskLimit &&
        (taskLimit.is_limit_reached || taskLimit.display_warning_banner)
      "
      class="px-6 py-3"
    >
      <div
        v-if="taskLimit.is_limit_reached"
        class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-2"
      >
        You have reached the maximum number of tasks you can create.
      </div>
      <div
        v-else-if="taskLimit.display_warning_banner"
        class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-2 rounded mb-2"
      >
        Warning: Only {{ taskLimit.max_count - taskLimit.current_count }} tasks
        left to create.
      </div>
    </div>
    <TaskStatusSection
      v-if="selectedStatus === 'Status' || selectedStatus === 'In Progress'"
      :tasks="filteredInProgressTasks"
      status="In Progress"
      :is-dropdown-visible="inProgressTasksDropdownVisible"
      :subtasks="subtasks"
      :subtask-visibility="subtaskVisibility"
      :talent-emails="talentEmails"
      :is-admin="isAdmin"
      :is-manager="isManager"
      :taskLimit="taskLimit"
      @toggle-dropdown="toggleInProgressTaskDropdown"
      @toggle-subtasks="toggleSubtasks"
      @open-side-menu="openSideMenu"
      @open-task-modal="openTaskModal"
      @delete-task="deleteTask"
      @open-create-sub-task-modal="openSubTaskModal"
      @open-duplicate-task-modal="openDuplicateTaskModal"
      @open-edit-task-modal="openEditTaskModal"
      @open-duplicate-sub-task-modal="openDuplicateSubTaskModal"
      @open-rename-task-modal="openRenameTaskModal"
    />

    <!-- Not Started Tasks -->
    <TaskStatusSection
      v-if="selectedStatus === 'Status' || selectedStatus === 'Not Started'"
      :tasks="filteredNotStartedTasks"
      status="Not Started"
      :is-dropdown-visible="notStartedTasksDropdownVisible"
      :subtasks="subtasks"
      :subtask-visibility="subtaskVisibility"
      :talent-emails="talentEmails"
      :is-admin="isAdmin"
      :is-manager="isManager"
      :taskLimit="taskLimit"
      @toggle-dropdown="toggleNotStartedTaskDropdown"
      @toggle-subtasks="toggleSubtasks"
      @open-side-menu="openSideMenu"
      @open-task-modal="openTaskModal"
      @delete-task="deleteTask"
      @open-create-sub-task-modal="openSubTaskModal"
      @open-duplicate-task-modal="openDuplicateTaskModal"
      @open-edit-task-modal="openEditTaskModal"
      @open-duplicate-sub-task-modal="openDuplicateSubTaskModal"
      @open-rename-task-modal="openRenameTaskModal"
    />

    <!-- Done Tasks -->
    <TaskStatusSection
      v-if="selectedStatus === 'Status' || selectedStatus === 'Done'"
      :tasks="filteredDoneTasks"
      status="Done"
      :is-dropdown-visible="doneTasksDropdownVisible"
      :subtasks="subtasks"
      :subtask-visibility="subtaskVisibility"
      :talent-emails="talentEmails"
      :is-admin="isAdmin"
      :is-manager="isManager"
      :taskLimit="taskLimit"
      @toggle-dropdown="toggleDoneTaskDropdown"
      @toggle-subtasks="toggleSubtasks"
      @open-side-menu="openSideMenu"
      @open-task-modal="openTaskModal"
      @delete-task="deleteTask"
      @open-create-sub-task-modal="openSubTaskModal"
      @open-duplicate-task-modal="openDuplicateTaskModal"
      @open-edit-task-modal="openEditTaskModal"
      @open-duplicate-sub-task-modal="openDuplicateSubTaskModal"
      @open-rename-task-modal="openRenameTaskModal"
    />

    <!-- Completed Tasks -->
    <TaskStatusSection
      v-if="selectedStatus === 'Status' || selectedStatus === 'Completed'"
      :tasks="filteredCompletedTasks"
      status="Completed"
      :is-dropdown-visible="completedTasksDropdownVisible"
      :subtasks="subtasks"
      :subtask-visibility="subtaskVisibility"
      :talent-emails="talentEmails"
      :is-admin="isAdmin"
      :is-manager="isManager"
      :taskLimit="taskLimit"
      @toggle-dropdown="toggleCompletedTaskDropdown"
      @toggle-subtasks="toggleSubtasks"
      @open-side-menu="openSideMenu"
      @open-task-modal="openTaskModal"
      @delete-task="deleteTask"
      @open-create-sub-task-modal="openSubTaskModal"
      @open-duplicate-task-modal="openDuplicateTaskModal"
      @open-edit-task-modal="openEditTaskModal"
      @open-duplicate-sub-task-modal="openDuplicateSubTaskModal"
      @open-rename-task-modal="openRenameTaskModal"
    />
    <!-- </div> -->
  </div>

  <div
    v-if="isSideMenuOpen"
    class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
    @click="closeSideMenu"
  ></div>

  <div
    v-if="isSideMenuOpen"
    class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px] overflow-y-auto"
  >
    <div class="space-y-4">
      <div
        class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight"
      >
        <h3 class="text-[16px] font-medium truncate">
          {{ selectedTask?.title }}
        </h3>
        <div class="flex space-x-2 items-center">
          <!-- <img
            src="@/assets/tasks/paperclip.svg"
            alt="Options"
            class="h-6 cursor-pointer"
          />
          <img
            src="@/assets/projects/options.svg"
            alt="Options"
            class="h-6 cursor-pointer"
          /> -->
          <div
            @click="closeSideMenu"
            class="bg-[#FAFBFC] h-8 rounded-full flex items-center justify-center"
          >
            <img
              src="@/assets/tasks/iconoir_cancel.svg"
              alt="Options"
              class="h-6 cursor-pointer"
            />
          </div>
        </div>
      </div>
      <TabComponent
        :tabs="sideMenuTab"
        v-model="activeSideMenuTab"
        :compact="false"
        class="mx-4"
      />

      </div>
    <div v-if="activeSideMenuTab === 'Details'">
      <div
        class="px-5 py-4 border-grayLight border-b-[1px] space-y-4 text-grayDark text-[13px]"
      >
        <div class="space-y-3">
          <div class="flex space-x-[68px] item-center text-[13px]">
            <div class="flex w-[88px] space-x-2 items-center">
              <img
                src="@/assets/tasks/status.svg"
                alt="Options"
                class="h-4 cursor-pointer"
              />
              <p>Status</p>
            </div>
            <div class="flex items-center space-x-4">
              <div
                class="relative"
                ref="dropdown"
                @click="stopEventPropagation"
              >
                <!-- Dropdown Toggle -->
                <div
                  @click="
                    toggleStatusDropdown('notStartedTasksDropdownVisible')
                  "
                  class="flex items-center space-x-3 cursor-pointer"
                >
                  <span class="flex items-center text-[13px] font-medium gap-2">
                    <div
                      class="w-[6px] h-[6px] bg-[#E0921E] rounded-full"
                    ></div>
                    {{ selectedTaskStatus }} - {{ notStartedTasks.length }}
                  </span>
                  <img
                    :src="require('@/assets/projects/Vector.svg')"
                    alt="Toggle"
                    class="w-2 h-3"
                  />
                </div>

                <!-- Dropdown Options -->
                <div
                  v-if="notStartedTasksDropdownStatusVisible"
                  class="absolute bg-white shadow-md mt-2 border rounded p-2 z-50"
                >
                  <div
                    @click="handleTaskStatusChange('Not Started')"
                    class="p-2 cursor-pointer hover:bg-gray-100"
                  >
                    Not Started
                  </div>
                  <div
                    @click="handleTaskStatusChange('In Progress')"
                    class="p-2 cursor-pointer hover:bg-gray-100"
                  >
                    In Progress
                  </div>
                  <div
                    @click="handleTaskStatusChange('Done')"
                    class="p-2 cursor-pointer hover:bg-gray-100"
                  >
                    Done
                  </div>
                </div>
              </div>

              <div v-if="selectedTask.task_status !== 'Completed'">
                <p
                  class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-2 py-1 border border-grayLight"
                  @click="
                    markTaskAsComplete(selectedTask.task_id, project.project_id)
                  "
                >
                  <img
                    src="@/assets/tasks/tick-circle.svg"
                    alt="Options"
                    class="h-4 cursor-pointer"
                  />
                  Mark as complete
                </p>
              </div>

              <div v-if="selectedTask.task_status === 'Completed'">
                <p
                  class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-2 py-1 border border-grayLight"
                >
                  <img
                    src="@/assets/tasks/tick-circle.svg"
                    alt="Unmark Icon"
                    class="h-4 cursor-pointer"
                  />
                  Completed
                </p>
              </div>
            </div>
          </div>

          <!-- Assign tasks to talent -->
          <div class="flex space-x-[68px] item-center">
            <div class="flex w-[88px] space-x-2 items-center">
              <img
                src="@/assets/tasks/user.svg"
                alt="Options"
                class="h-4 cursor-pointer"
              />
              <p>Assignees</p>
            </div>
            <div
              ref="dropdown"
              @click="stopEventPropagation"
              class="flex gap-2 items-center relative"
            >
              <div v-if="selectedTask.talent">
                <p class="py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ selectedTask.talent.first_name }}
                  {{ selectedTask.talent.last_name }}
                </p>
              </div>
              <div v-else-if="selectedTask.team">
                <template
                  v-for="member in selectedTask.team.members"
                  :key="member.id"
                >
                  <p class="py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ member.first_name }} {{ member.last_name }}
                  </p>
                </template>
              </div>
              <div v-else>
                <p class="py-4 whitespace-nowrap text-sm text-gray-500">
                  Unassigned
                </p>
              </div>
              <span v-if="isManager || isAdmin">
                <img
                  :src="require('@/assets/projects/Vector.svg')"
                  alt="Toggle"
                  class="w-2 h-3 cursor-pointer"
                  @click="toggleTaskAssigneeDropdown"
                />
              </span>

              <!-- Dropdown for selecting task assignee -->
              <div
                v-if="taskAssigneeDropdownVisible"
                class="absolute bg-white shadow-md mt-2 border rounded p-2 w-auto top-10 z-20"
              >
                <div
                  v-for="member in members"
                  :key="member.talent_id"
                  @click="handleTaskAssigneeChange(member.talent_id)"
                  class="p-2 cursor-pointer hover:bg-gray-100"
                >
                  {{ member.talent_first_name }}
                  {{ member.talent_last_name }} ({{ member.talent_email }})
                </div>
              </div>
            </div>
          </div>
          <div class="flex space-x-[68px] item-center">
            <div class="flex w-[88px] space-x-2 items-center">
              <img
                src="@/assets/tasks/calendar-2.svg"
                alt="Options"
                class="h-4 cursor-pointer"
              />
              <p>Due date</p>
            </div>
            <span class="">{{ formatDate(selectedTask?.due_date) }}</span>
          </div>
          <div class="flex space-x-[68px] item-center">
            <div class="flex w-[88px] space-x-2 items-center">
              <img
                src="@/assets/tasks/flag.svg"
                alt="Options"
                class="h-4 cursor-pointer"
              />
              <p>Priority</p>
            </div>
            <span class="">{{ selectedTask?.priority }}</span>
          </div>
          <div class="flex space-x-10 item-center">
            <div class="flex w-[115px] space-x-2 items-center">
              <img
                src="@/assets/tasks/timer.svg"
                alt="Options"
                class="h-4 cursor-pointer"
              />
              <p>Estimated time</p>
            </div>
            <span class="">Empty</span>
          </div>
        </div>
      </div>
      <!-- Description -->
      <div class="p-4 space-y-4">
        <div>
          <label class="block text-[14px] font-medium text-gray-700"
            >Description</label
          >
          <textarea
            v-model="selectedTask.description"
            @blur="updateTaskDescription"
            placeholder="Enter task description"
            class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            required
          ></textarea>
        </div>
        <button
          v-if="isAdmin || (isManager && editingDescription)"
          @click="updateTaskDescription"
          class="flex bg-primaryDarkBg hover:bg-primaryDark text-primaryLight justify-center text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] w-[100%] h-[42px]"
        >
          Save
        </button>
      </div>

      <!-- Subtasks Section -->
      <div class="p-4 space-y-4">
        <div>
          <div class="flex justify-between">
            <label class="block text-[14px] font-medium text-gray-700"
              >Subtasks</label
            >
            <div class="flex items-center">
              <div
                class="relative w-[200px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
              >
                <!-- Inner progress bar -->
                <div
                  class="absolute top-0 left-0 h-full bg-successText rounded-full"
                  :style="{ width: `${subtaskProgress}%` }"
                ></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">
                {{ completedSubtasks }}/{{ totalSubtasks }}
              </span>
            </div>
          </div>

          <!-- Show subtasks table only if there are subtasks for the selected task -->
          <div
            v-if="selectedTask.sub_tasks && selectedTask.sub_tasks.length > 0"
            class="mt-3"
          >
            <table class="min-w-full border border-[#E5E7ED] rounded-lg">
              <thead class="">
                <tr class="text-[12px] text-bodyText">
                  <th scope="col" class="px-4 py-3 text-left tracking-wider">
                    Name
                  </th>
                  <th scope="col" class="px-4 py-3 text-left tracking-wider">
                    Assignee
                  </th>
                  <th scope="col" class="px-4 py-3 text-left tracking-wider">
                    Due Date
                  </th>
                  <th scope="col" class="px-4 py-3 text-left tracking-wider">
                    Priority
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr
                  v-for="subtask in selectedTask?.sub_tasks"
                  :key="subtask.task_id"
                  class="cursor-pointer text-[12px] text-grayDark hover:bg-gray-100"
                >
                  <!-- Name column -->
                  <td
                    class="flex items-center gap-2 px-4 py-3 whitespace-nowrap text-bodyText truncate max-w-[150px]"
                  >
                    <img
                      src="@/assets/tasks/status-1.svg"
                      alt="Task icon"
                      class="h-3 w-3"
                    />
                    <div class="flex items-center gap-2">
                      <p
                        @click="openSideMenu(subtask)"
                        class="cursor-pointer hover:text-blue-600"
                      >
                        {{ subtask.title }}
                      </p>
                    </div>
                  </td>

                  <!-- Assignee column -->
                  <td class="px-4 py-3 whitespace-nowrap text-[11px]">
                    <span v-if="subtask.talent">
                      {{ subtask.talent.first_name }}
                      {{ subtask.talent.last_name }}
                    </span>
                    <span v-else-if="subtask.team">
                      <template
                        v-for="member in subtask.team.members"
                        :key="member.id"
                      >
                        {{ member.first_name }} {{ member.last_name }}
                      </template>
                    </span>
                    <span v-else> Unassigned </span>
                  </td>

                  <!-- Due Date column -->
                  <td class="px-4 py-3 whitespace-nowrap text-[11px]">
                    {{
                      subtask.due_date
                        ? formatDate(subtask.due_date)
                        : "No Due Date"
                    }}
                  </td>

                  <!-- Priority column -->
                  <td class="px-4 py-3 whitespace-nowrap">
                    <div class="flex items-center gap-1">
                      <img
                        src="@/assets/tasks/flag.svg"
                        alt="Priority"
                        class="h-3 w-3"
                      />
                      <span class="text-[11px]">{{
                        subtask.priority || "None"
                      }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Add New Subtask Button -->
            <div class="px-4 py-3 mt-4">
              <button
                @click="addNewSubtask"
                class="flex items-center gap-2 text-[13px] text-grayDark hover:text-blue-800 cursor-pointer"
              >
                <div class="p-1 bg-[#EFF4FF] rounded-[4px]">
                  <img
                    src="@/assets/tasks/add.svg"
                    alt="add icon"
                    class="h-4 w-4"
                  />
                </div>

                <span>Add subtask</span>
              </button>
            </div>
          </div>

          <!-- Show message when no subtasks exist -->
          <div v-else class="mt-3 text-center py-8 text-gray-500 text-[13px]">
            <!-- Add New Subtask Button -->
            <div class="px-4 py-3 mt-4">
              <button
                @click="addNewSubtask"
                class="flex items-center gap-2 text-[13px] text-grayDark hover:text-blue-800 cursor-pointer"
              >
                <div class="p-1 bg-[#EFF4FF] rounded-[4px]">
                  <img
                    src="@/assets/tasks/add.svg"
                    alt="add icon"
                    class="h-4 w-4"
                  />
                </div>

                <span>Add subtask</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CreateSubtaskModal
    ref="createSubTaskModal"
    :showModal="showCreateSubTaskModal"
    :parentTaskId="selectedTask?.task_id"
    :projectId="project.project_id"
    :members="subTaskMembers"
    :talentName="talentName"
    :talentEmails="talentEmails"
    :prefilledSubtask="prefilledTask"
    @close="closeCreateSubtaskModal"
    @subtask-created="handleSubtaskCreated"
  />
</template>

<script>
import apiClient from "@/axios";
import TaskStatusSection from "./TaskStatusSection.vue";
import TabComponent from "../profiles/TabComponent.vue";
import CreateSubtaskModal from "@/components/modals/CreateSubtaskModal.vue";

export default {
  name: "TaskTableComponent",
  components: {
    TaskStatusSection,
    TabComponent,
    CreateSubtaskModal,
  },
  emits: ["open-task-modal", "rename-task-modal", "edit-task-modal"],

  props: {
    selectedStatus: {
      type: String,
      default: "All",
    },
    selectedAssignee: {
      type: Object,
      default: () => null,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    talentName: {
      type: String,
      default: "",
    },
    talentEmail: {
      type: String,
      default: "",
    },
    taskLimit: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      showCreateSubTaskModal: false,
      activeSideMenuTab: "Details",
      sideMenuTab: ["Details", "Activity"],
      talentEmails: {},
      taskAssigneeDropdownVisible: false,
      members: [],
      subTaskMembers: [],
      editingDescription: false,
      prefilledTask: null,
      selectedTask: {},
      selectedTaskStatus: "Not Started",
      notStartedTasksDropdownStatusVisible: false,
      isSideMenuOpen: false,
      inProgressTasksDropdownVisible: true,
      doneTasksDropdownVisible: false,
      completedTasksDropdownVisible: false,
      notStartedTasksDropdownVisible: false,
      project: {
        project_id: "",
        project_name: "",
        description: "",
        start_date: "",
        end_date: "",
      },
      tasks: [],
      subtasks: {}, // Store subtasks by task ID: { taskId: [subtasks] }
      subtaskVisibility: {},
      filters: {
        task_status: "All",
        assignee: null,
        due_date: { start: null, end: null },
      },
      currentLastTaskUpdate: null,
      pollingInterval: null,
    };
  },
  watch: {
    "$route.params.projectId": {
      immediate: true,
      handler(newProjectId) {
        if (newProjectId) {
          this.fetchProject();
          this.setupPolling();
        }
      },
    },
    startDate: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.project.project_id) {
          this.fetchTasks(this.project.project_id);
        }
      },
    },
    endDate: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.project.project_id) {
          this.fetchTasks(this.project.project_id);
        }
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    inProgressTasks() {
      return this.tasks.filter((task) => task.task_status === "In Progress");
    },
    completedTasks() {
      return this.tasks.filter((task) => task.task_status === "Completed");
    },
    notStartedTasks() {
      return this.tasks.filter((task) => task.task_status === "Not Started");
    },

    // Tasks filtered by both status and assignee for "In Progress"
    filteredInProgressTasks() {
      return this.tasks.filter((task) => {
        const matchesStatus = task.task_status === "In Progress";
        const matchesAssignee =
          !this.selectedAssignee ||
          task.assigned_to === this.selectedAssignee.talent_id;
        return matchesStatus && matchesAssignee;
      });
    },

    // Tasks filtered by both status and assignee for "Completed"
    filteredCompletedTasks() {
      return this.tasks.filter((task) => {
        const matchesStatus = task.task_status === "Completed";
        const matchesAssignee =
          !this.selectedAssignee ||
          task.assigned_to === this.selectedAssignee.talent_id;
        return matchesStatus && matchesAssignee;
      });
    },

    // Tasks filtered by both status and assignee for "Not Started"
    filteredNotStartedTasks() {
      return this.tasks.filter((task) => {
        const matchesStatus = task.task_status === "Not Started";
        const matchesAssignee =
          !this.selectedAssignee ||
          task.assigned_to === this.selectedAssignee.talent_id;
        return matchesStatus && matchesAssignee;
      });
    },

    filteredDoneTasks() {
      return this.tasks.filter((task) => {
        const matchesStatus = task.task_status === "Done";
        const matchesAssignee =
          !this.selectedAssignee ||
          task.assigned_to === this.selectedAssignee.talent_id;
        return matchesStatus && matchesAssignee;
      });
    },

    filteredInProgressSubtasks() {
      const subtasks = [];
      this.filteredInProgressTasks.forEach((task) => {
        const taskSubtasks = this.subtasks[task.task_id] || [];
        const filtered = taskSubtasks.filter((subtask) => {
          const matchesAssignee =
            !this.selectedAssignee ||
            subtask.assigned_to === this.selectedAssignee.talent_id;
          return matchesAssignee;
        });
        if (filtered.length > 0) {
          subtasks.push({
            taskId: task.task_id,
            taskTitle: task.title,
            subtasks: filtered,
          });
        }
      });
      return subtasks;
    },

    filteredCompletedSubtasks() {
      const subtasks = [];
      this.filteredCompletedTasks.forEach((task) => {
        const taskSubtasks = this.subtasks[task.task_id] || [];
        const filtered = taskSubtasks.filter((subtask) => {
          const matchesAssignee =
            !this.selectedAssignee ||
            subtask.assigned_to === this.selectedAssignee.talent_id;
          return matchesAssignee;
        });
        if (filtered.length > 0) {
          subtasks.push({
            taskId: task.task_id,
            taskTitle: task.title,
            subtasks: filtered,
          });
        }
      });
      return subtasks;
    },

    filteredNotStartedSubtasks() {
      const subtasks = [];
      this.filteredNotStartedTasks.forEach((task) => {
        const taskSubtasks = this.subtasks[task.task_id] || [];
        const filtered = taskSubtasks.filter((subtask) => {
          const matchesAssignee =
            !this.selectedAssignee ||
            subtask.assigned_to === this.selectedAssignee.talent_id;
          return matchesAssignee;
        });
        if (filtered.length > 0) {
          subtasks.push({
            taskId: task.task_id,
            taskTitle: task.title,
            subtasks: filtered,
          });
        }
      });
      return subtasks;
    },

    filteredDoneSubtasks() {
      const subtasks = [];
      this.filteredDoneTasks.forEach((task) => {
        const taskSubtasks = this.subtasks[task.task_id] || [];
        const filtered = taskSubtasks.filter((subtask) => {
          const matchesAssignee =
            !this.selectedAssignee ||
            subtask.assigned_to === this.selectedAssignee.talent_id;
          return matchesAssignee;
        });
        if (filtered.length > 0) {
          subtasks.push({
            taskId: task.task_id,
            taskTitle: task.title,
            subtasks: filtered,
          });
        }
      });
      return subtasks;
    },
    totalSubtasks() {
      return this.subtasks[this.selectedTask?.task_id]?.length || 0;
    },
    completedSubtasks() {
      return (
        this.subtasks[this.selectedTask?.task_id]?.filter(
          (subtask) => subtask.task_status === "Completed"
        ).length || 0
      );
    },
    subtaskProgress() {
      if (this.totalSubtasks === 0) return 0;
      return Math.round((this.completedSubtasks / this.totalSubtasks) * 100);
    },
  },
  methods: {
    setupPolling() {
      this.clearPolling();

      this.pollingInterval = setInterval(() => {
        const token = localStorage.getItem("token");
        if (!token) {
          this.clearPolling();
          return;
        }
        if (!this.project.project_id) return;
        this.checkForUpdates();
      }, 60000);
    },
    clearPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    addNewSubtask() {
      this.showCreateSubTaskModal = true;
      if (this.$refs.createSubTaskModal) {
        this.$refs.createSubTaskModal.clearErrorMessage(); // Use the ref to call the method
      }
    },
    openSubTaskModal(item) {
      this.selectedTask = item;
      this.prefilledTask = null;
      if (item.talent) {
        this.subTaskMembers.push(item.talent);
      }

      if (item.team && item.team.members.length > 0) {
        this.subTaskMembers = [...this.subTaskMembers, ...item.team.members];
      }

      this.showCreateSubTaskModal = true;
      console.log("showCreateSubTaskModal:", this.showCreateSubTaskModal);
      if (this.$refs.createSubTaskModal) {
        this.$refs.createSubTaskModal.clearErrorMessage();
      }
    },

    closeCreateSubtaskModal() {
      this.showCreateSubTaskModal = false;
      // Refresh subtasks when modal closes
      this.fetchTasks(this.project.project_id);
      // if (this.selectedTask?.task_id) {
      //   this.fetchSubtasks(this.selectedTask.task_id);
      // }
    },
    clearErrorMessage() {
      console.log("Legacy: Clearing error message in parent component");
    },

    openDuplicateTaskModal(task) {
      this.$emit("open-task-modal", task);
    },
    openEditTaskModal(task) {
      this.$emit("edit-task-modal", task);
    },
    openDuplicateSubTaskModal(subtask) {
      this.selectedTask = subtask;
      this.prefilledTask = subtask;
      if (subtask.talent) {
        this.subTaskMembers.push(subtask.talent);
      }

      if (subtask.team && subtask.team.members.length > 0) {
        this.subTaskMembers = [...this.subTaskMembers, ...subtask.team.members];
      }

      this.showCreateSubTaskModal = true;
      if (this.$refs.createSubTaskModal) {
        this.$refs.createSubTaskModal.clearErrorMessage();
      }
    },
    openTaskModal() {
      this.$emit("open-task-modal");
    },
    handleSubtaskCreated(data) {
      console.log("Subtask created:", data);
      this.$toast.success(data.message);

      // Refresh subtasks for the current task
      // this.fetchSubtasks(this.selectedTask.task_id);
      this.fetchTasks(this.project.project_id);
      // Close the modal
      this.showCreateSubTaskModal = false;
    },
    async deleteTask(item) {
      try {
        await apiClient.delete(
          `/web/tasks/${item.task_id}?project_id=${this.project.project_id}`
        );
        this.$toast.success("You have successfully deleted this task");
        this.fetchTasks(this.project.project_id);
      } catch (error) {

        // Handle specific error cases
        if (error.response && error.response.status === 403) {
          this.$toast.error(
            "You are not allowed to delete this task. Only the task creator can delete this task."
          );
        } else if (error.response && error.response.status === 401) {
          this.$toast.error(
            "You are not authorized to perform this action. Please log in again."
          );
        } else if (error.response && error.response.status === 404) {
          this.$toast.error("Task not found. It may have been deleted.");
        } else if (error.response && error.response.status >= 500) {
          this.$toast.error("Server error occurred. Please try again later.");
        } else {
          this.$toast.error(
            "An error occurred while deleting the task. Please try again."
          );
        }
      }
    },
    async openRenameTaskModal(task) {
      this.$emit("rename-task-modal", task);
    },

    toggleTaskAssigneeDropdown() {
      this.taskAssigneeDropdownVisible = !this.taskAssigneeDropdownVisible;
    },
    // toggleSubtasks(taskId) {
    //   this.subtaskVisibility = {
    //     ...this.subtaskVisibility,
    //     [taskId]: !this.subtaskVisibility[taskId],
    //   };
    // },

    async toggleSubtasks(taskId) {
      // If subtasks aren't loaded yet, fetch them
      // if (!this.subtasks[taskId]) {
      //   await this.fetchSubtasks(taskId);
      // }

      this.subtaskVisibility = {
        ...this.subtaskVisibility,
        [taskId]: !this.subtaskVisibility[taskId],
      };
    },
    hasSubtasks(taskId) {
      return this.subtasks[taskId] && this.subtasks[taskId].length > 0;
    },
    closeDropdown() {
      this.taskAssigneeDropdownVisible = false;
    },
    stopEventPropagation(event) {
      event.stopPropagation();
    },
    async handleTaskAssigneeChange(talentId) {
      try {
        const payload = {
          assigned_to: talentId,
          // title: this.selectedTask.title,
          // description: this.selectedTask.description,
          // priority: this.selectedTask.priority,
          // task_status: this.selectedTask.task_status,
          // due_date: this.selectedTask.due_date,
          // team_id: null
        };
        // await this.$axios.put(`/web/tasks/${this.selectedTask.task_id}`, {
        //   assigned_to: talentId
        // });
        await apiClient.put(
          `/web/tasks/${this.selectedTask.task_id}?project_id=${this.selectedTask.project_id}`,
          payload
        );
        this.$toast.success("You have successfully reassigned this task");

        const talent = this.members.find(
          (member) => member.talent_id === talentId
        );
        this.selectedTask.assigned_to = talentId;
        this.selectedTask.talent = {
          talent_id: talentId,
          first_name: talent.talent_first_name,
          last_name: talent.talent_last_name,
          email: talent.talent_email,
        };
        this.taskAssigneeDropdownVisible = false;
      } catch (error) {
        this.$toast.error("Failed to assign task");
        console.error("Failed to assign task:", error);
      }
    },

    async updateTaskDescription() {
      this.editingDescription = false;

      try {
        let formattedDate = this.selectedTask.due_date;
        if (formattedDate && !formattedDate.includes("T")) {
          formattedDate = `${formattedDate}T00:00:00.000Z`;
        }

        const payload = {
          assigned_to: this.selectedTask.assigned_to,
          title: this.selectedTask.title,
          description: this.selectedTask.description.trim(), // Ensure no extra spaces
          priority: this.selectedTask.priority,
          task_status: this.selectedTask.task_status,
          due_date: formattedDate,
        };

        await apiClient.put(
          `/web/tasks/${this.selectedTask.task_id}?project_id=${this.project.project_id}`,
          payload
        );

        this.$toast.success("Task description updated successfully");

        this.fetchTasks(this.project.project_id); // Refresh task list
      } catch (error) {
        console.error("Error updating task:", error);
        this.$toast.error(
          "An error occurred while updating the task description."
        );
      }
    },

    toggleStatusDropdown() {
      this.notStartedTasksDropdownStatusVisible =
        !this.notStartedTasksDropdownStatusVisible;
    },
    closeStatusDropdown() {
      this.notStartedTasksDropdownStatusVisible = false;
    },
    toggleDropdown(key) {
      this[key] = !this[key];
    },
    async updateTaskStatus(taskId, projectId, status) {
      try {
        let formattedDate = this.due_date;
        if (formattedDate && !formattedDate.includes("T")) {
          formattedDate = `${formattedDate}T00:00:00.000Z`;
        }

        const payload = {
          assigned_to: this.selectedTask.assigned_to,
          title: this.selectedTask.title,
          description: this.selectedTask.description,
          priority: this.selectedTask.priority,
          task_status: status, // Use the dynamic status
          due_date: formattedDate,
        };

        await apiClient.put(
          `/web/tasks/${taskId}?project_id=${projectId}`,
          payload
        );
        this.$toast.success(`Task changed to "${status}!"`);
        this.fetchTasks(projectId); // Refresh task list
        this.selectedTask.task_status = status; // Update the UI state
        this.notStartedTasksDropdownStatusVisible = false; // Close dropdown
      } catch (error) {
        console.error("Error updating task:", error);

        // Handle specific error cases
        if (error.response && error.response.status === 403) {
          this.$toast.error("You are not allowed to update this task. Only the task creator or assigned user can modify this task.");
        } else if (error.response && error.response.status === 401) {
          this.$toast.error("You are not authorized to perform this action. Please log in again.");
        } else if (error.response && error.response.status === 404) {
          this.$toast.error("Task not found. It may have been deleted.");
        } else if (error.response && error.response.status >= 500) {
          this.$toast.error("Server error occurred. Please try again later.");
        } else {
          this.$toast.error("An error occurred while updating the task. Please try again.");
        }
      }
    },

    handleTaskStatusChange(status) {
      if (this.selectedTask && status) {
        this.selectedTaskStatus = status;
        this.updateTaskStatus(
          this.selectedTask.task_id,
          this.project.project_id,
          status
        );
        this.notStartedTasksDropdownStatusVisible = false; // Close dropdown
      }
    },
    openSideMenu(task) {
      
      document.body.style.overflow = "hidden";

      this.selectedTask = task; // Set the selected task
      this.isSideMenuOpen = true; // Open the side menu
    },
    closeSideMenu() {
      this.isSideMenuOpen = false; // Close the side menu
      this.selectedTask = null; // Clear the selected task
      document.body.style.overflow = "auto";
    },
    toggleInProgressTaskDropdown() {
      this.inProgressTasksDropdownVisible =
        !this.inProgressTasksDropdownVisible;
    },
    toggleCompletedTaskDropdown() {
      this.completedTasksDropdownVisible = !this.completedTasksDropdownVisible;
    },
    toggleNotStartedTaskDropdown() {
      this.notStartedTasksDropdownVisible =
        !this.notStartedTasksDropdownVisible;
    },
    toggleDoneTaskDropdown() {
      this.doneTasksDropdownVisible = !this.doneTasksDropdownVisible;
    },
    formatDate(dateString) {
      if (!dateString) return "No Due Date";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    async markTaskAsComplete(taskId, projectId) {
      try {
        const payload = {
          task_status: "Completed", // Mark as completed
        };

        await apiClient.put(
          `/web/tasks/${taskId}?project_id=${projectId}`,
          payload
        );

        this.$toast.success(
          "You have successfully completed this task. Well done!"
        );
        this.fetchTasks(projectId); // Refresh task list
        this.selectedTask.task_status = "Completed"; // Update the UI state
      } catch (error) {

        // Handle specific error cases
        if (error.response && error.response.status === 403) {
          this.$toast.error(
            "You are not allowed to mark this task as completed. Only the task creator can complete this task."
          );
        } else if (error.response && error.response.status === 401) {
          this.$toast.error(
            "You are not authorized to perform this action. Please log in again."
          );
        } else if (error.response && error.response.status === 404) {
          this.$toast.error("Task not found. It may have been deleted.");
        } else if (error.response && error.response.status >= 500) {
          this.$toast.error("Server error occurred. Please try again later.");
        } else {
          this.$toast.error("An error occurred while updating the task. Please try again.");
        }
      }
    },

    async fetchTalentEmail(talentId) {
      if (this.talentEmails[talentId]) return; // Skip fetching if already cached

      try {
        const response = await apiClient.get(`/web/talents/${talentId}`);
        const email = response.data.data.user.email;
        this.talentEmails = {
          ...this.talentEmails,
          [talentId]: email,
        }; // Update reactive object
      } catch (error) {
        console.error(`Error fetching talent email for ID ${talentId}:`, error);
        this.talentEmails = {
          ...this.talentEmails,
          [talentId]: "N/A", // Set fallback value
        };
      }
    },

    async fetchTasks(projectId) {
      this.isLoading = true;
      try {
        const params = {};

        if (this.startDate) {
          params.start_date = this.startDate;
        }
        if (this.endDate) {
          params.end_date = this.endDate;
        }


        const response = await apiClient.get(
          `/web/projects/${projectId}/tasks`,
          {
            params,
          }
        );

        this.tasks = response.data.data;
        this.currentLastTaskUpdate = new Date(new Date().toISOString());
        // Fetch emails for assignees if not cached
        for (const task of this.tasks) {
          if (task.assigned_to && !this.talentEmails[task.assigned_to]) {
            await this.fetchTalentEmail(task.assigned_to);
          }
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async checkForUpdates() {
      try {
        const response = await apiClient.get(
          `/web/projects/${this.project.project_id}/last-update`
        );

        const lastUpdated = new Date(response.data.data.last_update_time);
        if (lastUpdated > this.currentLastTaskUpdate) {
          this.fetchTasks(this.project.project_id);
          this.currentLastTaskUpdate = lastUpdated;
        }
      } catch (error) {
        console.error("Error checking for updates:", error);
      }
    },
    // async fetchAllSubtasks() {
    // const subtaskPromises = this.tasks.map((task) =>
    //   this.fetchSubtasks(task.task_id)
    // );
    // await Promise.all(subtaskPromises);
    // },

    // async fetchSubtasks(taskId) {
    //   try {
    //     const response = await apiClient.get(`/web/tasks/${taskId}/subtasks`);

    //     // Vue 3 compatible way to set reactive data
    //     this.subtasks = {
    //       ...this.subtasks,
    //       [taskId]: response.data.data || [],
    //     };

    //     // Fetch emails for subtask assignees
    //     const taskSubtasks = this.subtasks[taskId] || [];
    //     for (const subtask of taskSubtasks) {
    //       if (subtask.assigned_to && !this.talentEmails[subtask.assigned_to]) {
    //         await this.fetchTalentEmail(subtask.assigned_to);
    //       }
    //     }
    //   } catch (error) {
    //     console.error(`Error fetching subtasks for task ${taskId}:`, error);
    //     this.subtasks = {
    //       ...this.subtasks,
    //       [taskId]: [],
    //     };
    //   }
    // },

    async fetchProject() {
      this.isLoading = true;
      const projectId = this.$route.params.projectId;
      try {
        const response = await apiClient.get(`/web/projects/${projectId}`);
        this.project = response.data.data;
        this.fetchTasks(projectId);
        this.fetchProjectMembers(projectId);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.$router.push({ name: "NotFound" });
        } else {
          console.error("Error fetching project:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },

    async fetchProjectMembers(projectId) {
      try {
        const response = await apiClient.get(
          `/web/projects/${projectId}/project_members/`
        );
        this.members = response.data.data;
      } catch (error) {
        console.error("Error fetching members data:", error);
      }
    },
  },
  created() {
    const projectId = this.$route.params.projectId;

    this.fetchProject();
    // this.fetchTalentEmail();
    this.fetchProjectMembers(projectId); // Fetch project members
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
    document.addEventListener("click", this.closeStatusDropdown);
  },
  beforeUnmount() {
    this.clearPolling();

    document.removeEventListener("click", this.closeDropdown);
    document.removeEventListener("click", this.closeStatusDropdown);
  },
};
</script>

<style scoped>
.fixed {
  transition: transform 0.3s ease-in-out;
}
.fixed[style*="transform: translateX(0%)"] {
  transform: translateX(0%);
}
.fixed[style*="transform: translateX(100%)"] {
  transform: translateX(100%);
}
.backdrop-blur-sm {
  backdrop-filter: blur(5px); /* Blur intensity */
}

/* Black transparent background */
.bg-opacity-40 {
  background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black */
}
</style>
